import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { WorkoutProgramBuilderPage } from '../pages/client/workout-program-builder/workout-program-builder.page';

export interface OpenWorkoutProgramBuilderModalOptions {
  id?: string;
  type?: 'user' | 'library';
  userId?: string;
  mode?: 'program' | 'template' | 'workout';
  duplicate?: string;
  source?: string;
  template?: string;
  kind?: string;
  backdropDismiss?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class WorkoutProgramBuilderModalService {
  constructor(private modalCtrl: ModalController) {}

  async open(options: OpenWorkoutProgramBuilderModalOptions = {}): Promise<OverlayEventDetail<any>> {
    const modal = await this.modalCtrl.create({
      component: WorkoutProgramBuilderPage,
      cssClass: 'meal-plan-side-modal',
      backdropDismiss: options.backdropDismiss ?? false,
      componentProps: {
        modalContext: {
          workoutProgramUser: options.userId,
          id: options.id || 'add',
          type: options.type || 'user',
          ...(options.mode ? { mode: options.mode } : {}),
          ...(options.duplicate ? { duplicate: options.duplicate } : {}),
          ...(options.source ? { source: options.source } : {}),
          ...(options.template ? { template: options.template } : {}),
          ...(options.kind ? { kind: options.kind } : {}),
        },
      },
    });

    await modal.present();
    return modal.onDidDismiss();
  }
}
